export default [
    {
        /** 退出系统 */
        name: 'queryArticleLists',
        url: '/lists'
    },
    {
        name: 'addArticle',
        url: '/add'
    },
    {
        name: 'updateArticle',
        url: '/update'
    },
    {
        name: 'deleteArticle',
        url: '/delete'
    },
    {
        name: 'queryArticle',
        url: '/detail'
    }
];
